import React, {FC, PropsWithChildren, ReactNode} from "react";
import "./ui.css";

// A labelled value inside a panel: a state, a read-only detail or an editable field.
export const FieldTile: FC<PropsWithChildren<{label: ReactNode; action?: ReactNode; detail?: ReactNode}>> = ({
    label,
    action,
    detail,
    children
}) => (
    <div className="ati-field-tile">
        <div className="ati-field-tile__label-row">
            <span className="ati-field-tile__label">{label}</span>
            {action}
        </div>
        <div className="ati-field-tile__value">{children}</div>
        {detail ? <span className="ati-field-tile__detail">{detail}</span> : null}
    </div>
);
